/** While the brain and email are not connected yet, pages can show made-up examples so a design can be judged.
 *  They are OFF by default, on your Mac (`npm run dev`) and on the server: only real data appears.
 *  Switch them on only for judging a design: `npm run dev:sample`, or `VITE_SAMPLE_DATA=true` at build time
 *  (the browser tests do this). */
export const SAMPLE_DATA = import.meta.env.VITE_SAMPLE_DATA === 'true';

/** A made-up list: empty when sample data is off, so nothing made-up can reach a real screen */
export const sampleOnly = <T>(items: T[]): T[] => (SAMPLE_DATA ? items : []);
